import { X } from "lucide-react";
import { Card, IconSelect, inputCls } from "./fields";

export default function ListsTab({ data = {}, update, idSuffix = "" }) {
  const listHandlers = (section) => {
    const items = data?.[section]?.items || [];
    return {
      add: () =>
        update(section, "items", [
          ...items,
          section === "faq" ? { q: "", a: "" } : { icon: "star", title: "", desc: "" },
        ]),
      update: (i, key, value) => {
        const next = [...items];
        next[i] = { ...next[i], [key]: value };
        update(section, "items", next);
      },
      remove: (i) => update(section, "items", items.filter((_, j) => j !== i)),
    };
  };

  const renderList = (section, handlers, withIcon) => (
    <div className="space-y-3">
      {(data?.[section]?.items || []).map((item, i) => (
        <div key={i} className="rounded-xl border border-line bg-white p-4" data-testid={`${section}-item-${i}${idSuffix}`}>
          <div className="flex items-start justify-between gap-3">
            <div className="w-full space-y-3">
              {withIcon && <IconSelect value={item?.icon || "star"} onChange={(v) => handlers.update(i, "icon", v)} />}
              {section !== "faq" ? (
                <>
                  <input className={inputCls} placeholder="العنوان" data-testid={`${section}-item-${i}-title${idSuffix}`} value={item?.title || ""} onChange={(e) => handlers.update(i, "title", e.target.value)} />
                  <textarea rows={2} className={inputCls} placeholder="الوصف" data-testid={`${section}-item-${i}-desc${idSuffix}`} value={item?.desc || ""} onChange={(e) => handlers.update(i, "desc", e.target.value)} />
                </>
              ) : (
                <>
                  <input className={inputCls} placeholder="السؤال" data-testid={`${section}-item-${i}-q${idSuffix}`} value={item?.q || ""} onChange={(e) => handlers.update(i, "q", e.target.value)} />
                  <textarea rows={3} className={inputCls} placeholder="الجواب" data-testid={`${section}-item-${i}-a${idSuffix}`} value={item?.a || ""} onChange={(e) => handlers.update(i, "a", e.target.value)} />
                </>
              )}
            </div>
            <button
              type="button"
              onClick={() => handlers.remove(i)}
              data-testid={`${section}-item-${i}-remove${idSuffix}`}
              aria-label="حذف العنصر"
              className="shrink-0 rounded-lg border border-line p-2 text-moss transition hover:border-brick hover:text-brick"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
      <button
        type="button"
        onClick={handlers.add}
        data-testid={`${section}-add${idSuffix}`}
        className="w-full rounded-xl border border-dashed border-gold px-4 py-3 text-sm font-bold text-gold-dark transition hover:bg-gold/10"
      >
        + إضافة عنصر جديد
      </button>
    </div>
  );

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <Card title="المميزات (مميزات التطبيق)" testid={`admin-card-features${idSuffix}`}>
        {renderList("features", listHandlers("features"), true)}
      </Card>
      <Card title="فوائد العملاء" testid={`admin-card-benefits${idSuffix}`}>
        {renderList("benefits", listHandlers("benefits"), true)}
      </Card>
      <Card title="الأسئلة الشائعة" testid={`admin-card-faq${idSuffix}`}>
        {renderList("faq", listHandlers("faq"), false)}
      </Card>
    </div>
  );
}
